module.exports = __webpack_public_path__ + "static/media/gerrit-vermeulen.821507c3.jpg";